
export default {
  props: ['value', 'cartItem', 'in-cart', 'diagram'],
  data () {
    return {
      isLoading: false
    }
  }
}
